import React, { useEffect, useState } from 'react';
import {Skeleton} from 'antd';
import PatientForm from './components/patient_form';
import {useParams} from 'react-router-dom';
import Sidebar from '../Sidebar';
import { useFirestore } from 'reactfire';
// import Loader from '../../Components/Loader';


const EditPatient = () => {
    let {id} = useParams();

    const [patient, setPatient] = useState();
    const firestore = useFirestore();
    const query = firestore.collection("patients").doc(id);

    const [loading, setLoading] = useState(false);

    useEffect(()=> {
        getCurrentPatient(id);
    }, [id])

    const getCurrentPatient = (id) => {
        setLoading(true);
        query.get().then((response) => {
            setPatient(response.data());
            setLoading(false);
        });

       
        // API.get(`patients/${id}`).then((response) => {
        //     setPatient(response.data);   
        // });
    }
    
    return (
        <React.Fragment>
            <Sidebar showAppointments={false}/>
            {/* <Header /> */}
            <div className='container'>
                <h2>Edit Patient</h2>
                <div className='card'>
                {loading ? <Skeleton active /> : <>
                    <PatientForm type="Edit" patient={patient} patientID={id} />
                   
                </>}
                </div>
            </div>
        </React.Fragment>
    );
}

export default EditPatient;
